import React from "react";
import Skeleton from "react-loading-skeleton";
import ProfilePageSkeleton from "../../profiles/ProfilePageSkeleton";
import SectionSkeleton from "../../profiles/SectionSkeleton";

// Media Profile loading state on the shared <ProfilePageSkeleton> chassis: a person-header
// placeholder + a stack of section-card placeholders + a rail placeholder (the Viewers-also-view
// card). Mirrors the common loaded layout so there's no reflow when data arrives.
function MediaHeaderSkeleton() {
  return (
    <div
      className="card p-4 animated fadeIn faster"
      style={{
        borderRadius: "8px",
        boxShadow: "0px 1px 2px -1px rgba(10, 13, 18, 0.1), 0px 1px 3px 0px rgba(10, 13, 18, 0.1)",
      }}
    >
      <div className="row">
        <div className="col-12 col-sm-auto d-flex justify-content-center mb-3 mb-sm-0">
          <Skeleton circle height={120} width={120} />
        </div>
        <div className="col">
          <Skeleton height={28} width="40%" />
          <Skeleton height={18} width="55%" className="mt-2" />
          <Skeleton height={14} width="30%" className="mt-2" />
        </div>
        <div className="col-12 col-md-auto mt-3 mt-md-0">
          <Skeleton height={14} width={160} />
          <Skeleton height={38} width={160} className="mt-2" />
        </div>
      </div>
    </div>
  );
}

function MediaProfileSkeleton() {
  return (
    <ProfilePageSkeleton header={<MediaHeaderSkeleton />} rightRail={<SectionSkeleton lines={5} />}>
      <SectionSkeleton lines={4} />
      <SectionSkeleton lines={2} />
      <SectionSkeleton lines={3} />
    </ProfilePageSkeleton>
  );
}

export default MediaProfileSkeleton;
